module.exports = __webpack_public_path__ + "8a6f31675cd15b9caf763ec13b13ddeb.png";